import { request } from './request'
// 字典项数据接口
function getDictTypeList(data) {
    return request({
        url: '/sys/dict/getDictTypeList',
        method: 'POST',
        data: data
    })
}

// 字典项数据接口列表
function getDictTypeListPage(data) {
    return request({
        url: '/sys/dictType/selectListPage',
        method: 'POST',
        data: data
    })
}

//字典项新增
function addDictType(data) {
    return request({
        url: '/sys/dictType/dictTypeSave',
        method: 'POST',
        data: data
    })
}

//id查询
function getDictTypeDetail(data) {
    return request({
        url: '/sys/dictType/getDictType',
        method: 'POST',
        data: data
    })
}

// 查询省市区
function selectAreaList(data) {
    return request({
        url: '/sys/sysArea/selectAreaList',
        method: 'POST',
        data: data
    })
}

export default {
    getDictTypeList,
    selectAreaList,
    getDictTypeListPage,
    addDictType,
    getDictTypeDetail
}
